// @flow

import { getCountry, getWithholdTaxes } from '@tectonics/prs/incoming-payment';
import { isLocalLatamTenantCode, isDiamondTenantCode } from '@tectonics/commons/tenant';
import { type IncomingPayment } from './types';

export function shouldHideAcceptTermsWithholdTaxes(
  incomingPayment: IncomingPayment,
  localTenancy: string
): boolean {
  const country = getCountry(incomingPayment);
  const withholdTaxes = getWithholdTaxes(incomingPayment);

  const shouldHideAcceptTerms = country !== 'ar' || withholdTaxes !== 'withhold_taxes';
  const isNotCrossBorderTenantCode = isLocalLatamTenantCode(localTenancy) || isDiamondTenantCode(localTenancy);

  return shouldHideAcceptTerms || isNotCrossBorderTenantCode;
}
